import React from 'react';
import { Document, Page, StyleSheet, View, Text, Image, Font, Link } from '@react-pdf/renderer';
import ProximaNovaRegular from 'Assets/font/proximanova_regular.ttf';
import ProximaNovaBold from 'Assets/font/ProximaNova-Bold.ttf';
import ProximaNovaThin from 'Assets/font/FontsFree-Net-Proxima-Nova-Thin.ttf';
import ProximaNovalight from 'Assets/font/proximanova_light.ttf';
import Proxima_Nova_Semibold from 'Assets/font/fonnts.com-Proxima_Nova_Semibold.ttf';
// import logo from "../../assets/image/LogoTagline.png";
// import attachments_img from "../../assets/image/attachments.png"
// import ellips_img from "../../assets/image/Ellipse 1.png";
// import InstaIcons from "../../assets/image/icons.png";
// import sendIcons from "../../assets/image/send.png";
// import callIcons from "../../assets/image/call.png";
import logo from "Assets/images/logo.png";
// import InstaIcons from "Assets/images/reportIntaIcon.png"
// import callIcons from "Assets/images/reportPhoneIcon.png"
// import attachments_img from "Assets/images/AttachmentIcon.png"
// import ellips_img from "Assets/images/AttachmentIcon.png"
// import clickIcon from "Assets/images/reportClickIcon.png"
// import { ClientDetailsPdf } from "./Components/ClientDetails";
// import { INDIVIDUAL_SESSION_REPORT_V2_QUESTIONS } from "config/constants";
// import { RenderAnswerByQId } from "./Components/AnswerFields/Index";
// import GoalReviewSection from "./Components/GoalReviewSection";
// import TherapistSignaturePdf from "./Components/TherapistSignature";
// import Html from "react-pdf-html";
// import { isValidValue } from "helpers/common";
// import ObservationsSection from './Components/ObservationsSection';
// import { PdfFooter } from './Components/PdfFooter';
// import AnswerMultipleRecommendations from './Components/AnswerFields/AnswerMultipleRecommendations';
// import AnswerEditor from './Components/AnswerFields/AnswerEditor';
import ProximaNovaRegularItalic from 'Assets/font/FontsFree-Net-Proxima-Nova-Reg-It.otf';
import ProximaNovaThinItalic from 'Assets/font/FontsFree-Net-Proxima-Nova-Thin-It.otf';
import ProximaNovaBoldItalic from 'Assets/font/FontsFree-Net-ProximaNovaBoldItalic.ttf';
import ProximaNovaSemiBoldItalic from 'Assets/font/FontsFree-Net-ProximaNovaSemiboldItalic.ttf';
import ProximaNovaLightItalic from 'Assets/font/FontsFree-Net-Proxima-Nova-Light-It.otf';
import { ClientDetailsPdf } from '../../../../../components/Reports/ReportPdfComponents/ClientDetails';
import PDFHtmlRenderer from '../../../../../components/Reports/ReportPdfComponents/PDFHtmlRenderer';
import { PdfFooter } from 'components/PdfFooter';
// import PDFHtmlRenderer from "./Components/PDFHtmlRenderer";

Font.register({
    family: 'Proxima Nova',
    fonts: [
        { src: ProximaNovaThin, fontWeight: 100 },         // thin
        { src: ProximaNovalight, fontWeight: 300 },        // light
        { src: ProximaNovaRegular, fontWeight: 400 },      // normal
        { src: Proxima_Nova_Semibold, fontWeight: 600 },   // semibold
        { src: ProximaNovaBold, fontWeight: 700 },         // bold
        { src: ProximaNovaThinItalic, fontWeight: 'thin', fontStyle: 'italic' },
        { src: ProximaNovaLightItalic, fontWeight: 'light', fontStyle: 'italic' },
        { src: ProximaNovaRegularItalic, fontWeight: 'normal', fontStyle: 'italic' },
        { src: ProximaNovaSemiBoldItalic, fontWeight: 'semibold', fontStyle: 'italic' },
        { src: ProximaNovaBoldItalic, fontWeight: 'bold', fontStyle: 'italic' },
    ],
});


const styles = StyleSheet.create({
    page: {
        color: "#000",
        padding: 20,
        backgroundColor: '#ffffff',
        fontFamily: 'Proxima Nova',
        paddingBottom: 100,
    },
    container: {
        padding: '0 40px 0 40px',
    },
    pageNumber: {
        textAlign: "right"
        // position: "absolute",
        // right: "10%"
    },
    fontBold: {
        fontFamily: 'Proxima Nova',
        fontWeight: 'bold'
    },
    fontSemibold: {
        fontFamily: 'Proxima Nova',
        fontWeight: 'semibold'
    },
    fontLight: {
        fontFamily: 'Proxima Nova',
        fontWeight: 'light'
    },
    headerRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: "flex-end",
        marginBottom: 20,
        padding: '0 40px 0 0',
    },
    logo: {
        width: 127,
    },
    headerTitle: {
        fontSize: 9,
        textAlign: 'center',
        fontWeight: 'bold',
    },
    subtitle: {
        fontSize: 16,
        textAlign: 'center',
        marginTop: 3,
        color: "#93278F"
    },
    border: {
        borderBottom: "1px solid #000",
        paddingBottom: "2px",
        marginBottom: "8px"
    },
    mainHeading: {
        fontSize: 10,
        fontWeight: 'semibold',
        fontFamily: 'Proxima Nova',
    },
    mainSubHeading: {
        fontSize: 8,
        fontWeight: 'semibold',
        fontFamily: 'Proxima Nova',
        letterSpacing: "1px",
        textTransform: "uppercase"
    },
    subHeading: {
        fontSize: 7,
        fontWeight: 'semibold',
    },
    para: {
        fontSize: 8,
        fontWeight: 'normal'
    },
    flex: {
        display: "flex",
        flexDirection: "row"
    },
    halfCol: {
        width: '50%',
    },
    mainSubHeadingWithOutSpacing: {
        fontSize: 8,
        fontWeight: 'thin',
        fontFamily: 'Proxima Nova',
        textTransform: "uppercase",
        color: "#000"
    },
    footer: {
        position: 'absolute',
        bottom: 20,
        left: 0,
        right: 0,
        fontSize: 10,
        // color: 'grey',
        padding: '0px 60px 0px 60px',
        // marginTop: "10px",
        marginBottom: "-10px",
    },
    link: {
        fontSize: 7,
        color: "#000",
        fontFamily: 'Proxima Nova',
        fontWeight: 'light',
        // borderBottom: "1px solid #333"
    }
});

const IntakePdfDocV2 = ({ data }) => {
    const reportQuestions = data?.reportQuestions;
    const reportAnswers = data?.reportAnswers;
    const reportRecommendations = data?.recommendation;

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View
                    style={styles.pageNumber}
                    render={({ pageNumber, totalPages }) => (
                        <Text style={{ ...styles.para }}>Page {pageNumber}/{totalPages}</Text>
                    )}
                    fixed
                ></View>
                <View style={styles.headerRow}>
                    <View>
                        <Image style={styles.logo} src={logo} />
                    </View>
                    <View style={{ alignItems: "flex-end" }}>
                        {/* <Text style={styles.subtitle}>{data?.therapist?.therapist_discipline?.name}</Text> */}
                        <Text style={styles.subtitle}>Home Education</Text>
                        <Text style={styles.subtitle}>Intake Session Report</Text>
                    </View>
                </View>

                <View style={styles.container}>
                    <View>
                        <View style={styles.border}>
                            <Text style={{ ...styles.mainHeading }}>CLIENT INFORMATION</Text>
                        </View>
                        <View style={{ ...styles.flex, justifyContent: "space-between" }}>
                            <ClientDetailsPdf
                                data={data}
                                styles={styles}
                            />
                        </View>


                        <View style={{ marginTop: "10px" }}>
                            {data?.selectedGuardians
                                ?.sort((a, b) => {
                                    console.log('a and b', a, b)
                                    if (a?.key === "teacher") return -1; // a comes first
                                    if (b?.key === "teacher") return 1;  // b comes first
                                    return 0; // order unchanged for teacher
                                })
                                ?.map((item, index) => (
                                    <View style={{ marginBottom: "10px" }}>
                                        <View style={{ borderBottom: "0.75px solid #000", paddingBottom: "2px", marginBottom: "5px" }}>
                                            <Text style={{ ...styles.mainSubHeading, textTransform: "uppercase" }}>{item.key || `Parent/guardian ${index + 1}`}</Text>
                                        </View>
                                        <View style={{ ...styles.flex, justifyContent: "space-between", marginBottom: 5 }}>
                                            <View style={{ gap: "3px" }}>
                                                <Text style={styles.subHeading}>LAST NAME</Text>
                                                <Text style={styles.para}>{item?.client_guardian?.lastname}</Text>
                                            </View>
                                            <View style={{ gap: "3px" }}>
                                                <Text style={styles.subHeading}>FIRST NAME</Text>
                                                <Text style={styles.para}>{item?.client_guardian?.firstname}</Text>
                                            </View>
                                            <View style={{ gap: "3px" }}>
                                                <Text style={styles.subHeading}>EMAIL</Text>
                                                <Text style={styles.para}>{item?.client_guardian?.email}</Text>
                                            </View>
                                            <View style={{ gap: "3px" }}>
                                                <Text style={styles.subHeading}>CITY/TOWN</Text>
                                                <Text style={styles.para}>{data?.city_town || "--"}</Text> 
                                            </View>
                                            {/* <View style={{ gap: "3px" }}>
                                                <Text style={styles.subHeading}>SCHOOL</Text>
                                                <Text style={styles.para}>{data?.schoolName}</Text>
                                            </View> */}
                                        </View>
                                    </View>
                                ))}

                        </View>
                        {/* <View style={{ ...styles.border }}>
                        <Text style={{ ...styles.mainHeading, fontSize: 10 }}>BACKGROUND</Text>
                    </View> */}
                        {/* {
                        data?.reportAnswers?.map((item, index) => {
                            if (item?.question_id == 97) {
                                return ( */}
                        {/* <PDFHtmlRenderer
                                        // key={index}
                                        style={{ ...styles?.para, fontSize: 9 }}
                                        // data={item?.answer?.answer}
                                        data={'Lorem ipsum dolor sit amet consectetur adipiscing elit libero, ultrices turpis cursus augue fusce dapibus maecenas, posuere vel blandit molestie ad nunc platea. In eget velit cras sociosqu varius mollis, inceptos luctus tortor nisl nam, a parturient ullamcorper suspendisse id.'}
                                    /> */}
                        {/* )
                            }
                        })
                    } */}
                        {/* <View style={{ ...styles.border, marginTop: "15px" }}>
                        <Text style={{ ...styles.mainHeading, fontSize: 10 }}>OBSERVATIONS</Text>
                    </View> */}
                        {/* <View>
                        <ObservationsSection
                            data={data?.observations}
                            chartImages={data?.images}
                            styles={styles}
                        />
                    </View> */}

                        {/* <View style={{ marginTop: "15px" }}>
                        <AnswerMultipleRecommendations
                            recommendations={reportRecommendations}
                            styles={styles}
                        />
                    </View> */}
                        <View style={{ marginTop: "15px", width: "100%" }}>
                            <View style={styles.border}>
                                <Text style={{ ...styles.mainHeading, fontSize: 10 }}>MEETING INFORMATION</Text>
                            </View>
                            <View>
                                <PDFHtmlRenderer
                                    // key={index}
                                    style={{ ...styles?.para, fontSize: 9 }}
                                    // data={item?.answer?.answer}
                                    data={data?.parent_report}
                                />
                            </View>
                            {/* <View style={{ marginTop: "10px", ...styles.flex, gap: "12px" }}>
                            <View>
                                <TherapistSignaturePdf
                                    data={data}
                                />
                            </View>
                        </View> */}
                        </View>
                        <View style={{ marginTop: "15px", width: "100%" }}>
                            <View style={styles.border}>
                                <Text style={{ ...styles.mainHeading, fontSize: 10 }}>RECOMMENDATIONS</Text>
                            </View>
                            <View>
                                <PDFHtmlRenderer
                                    // key={index}
                                    style={{ ...styles?.para, fontSize: 9 }}
                                    // data={item?.answer?.answer}
                                    data={data?.recommendations}
                                />
                            </View>
                            {/* <View style={{ marginTop: "10px", ...styles.flex, gap: "12px" }}>
                            <View>
                                <TherapistSignaturePdf
                                    data={data}
                                />
                            </View>
                        </View> */}
                        </View>
                    </View>
                </View>
                {/* <View style={styles.footer}>
                    <View style={styles.border}></View>
                    <View>
                        <Text style={{ ...styles.para, ...styles.fontBold, alignItems: "flex-start" }}>
                            KHAN COMMUNICATION SERVICES
                        </Text>
                        <View style={{ ...styles.flex, justifyContent: "space-between", alignItems: "center", marginTop: "5px" }}>
                            <View style={{ ...styles.flex, alignItems: "center", gap: "4px" }}>
                                <Image style={{ width: 11, height: 11 }} src={InstaIcons} />
                                <Text style={{ ...styles.para, color: "#315D99" }}>
                                    @khancommservices
                                </Text>
                            </View>
                            <View style={{ ...styles.flex, alignItems: "center", gap: "4px" }}>
                                <Image style={{ width: 11, height: 11 }} src={clickIcon} />
                                <Text style={{ ...styles.para, color: "#315D99" }}>
                                    www.khancommunicationservices.com
                                </Text>
                            </View>
                            <View style={{ ...styles.flex, alignItems: "center", gap: "4px" }}>
                                <Image style={{ width: 11, height: 11 }} src={callIcons} />
                                <Text style={{ ...styles.para, color: "#315D99" }}>
                                    (780)-440-3251
                                </Text>
                            </View>
                        </View>
                    </View>
                </View> */}
                <PdfFooter data={data} />
            </Page>
        </Document>
    )
};

export default IntakePdfDocV2;